import React from "react";

const RAIL_ITEMS = [
    { id: "kore", label: "Kore.co", icon: "/images/korelogo.svg" },
    { id: "claritick", label: "Claritick", icon: "/images/claritick-platform.svg", current: true },
    { id: "claritask", label: "Claritask", icon: "/images/claritask-light.svg" },
    { id: "sendbat", label: "Sendbat", icon: "/images/sendbat-light.svg" },
];

const MockPlatformRail = () => (
    <aside className="clk-mk-platform-rail" aria-label="Platform apps">
        {RAIL_ITEMS.map((item) => (
            <button
                key={item.id}
                type="button"
                className={`clk-mk-platform-item${item.current ? " is-current" : ""}`}
                title={item.label}
                aria-label={item.label}
            >
                <img src={item.icon} alt="" />
            </button>
        ))}
    </aside>
);

export default MockPlatformRail;
